<template>
	<div class="job-evaluation-job-card tw-flex tw-flex-col" :class="{ selected }">
		<div class="job-evaluation-job-card-info tw-flex-auto tw-flex tw-flex-col tw-items-center tw-justify-center">
			<div  class="tw-flex tw-items-end tw-flex-1" v-if="!selected">
				<check-icon-filled  width="30" height="30" :disabled="!job.completed" class="tw-mb-4" />
			</div>
			<div class="job-evaluation-job-card-name tw-flex-1 tw-flex" :class="{'tw-items-center': selected}">
				{{ job.name }}
			</div>
		</div>
		<div v-if="job.completed || selected" class="job-evaluation-job-card-rate tw-flex tw-justify-center tw-items-center">
			<span ><small>Puntaje:</small> {{ job.rate }}</span>
		</div>
	</div>
</template>

<script>
import CheckIconFilled from '@/modules/shared/components/icons/check-icon-filled';

export default {
	name: 'JobEvaluationJobCard',
	components: { CheckIconFilled },
	props: ['job', 'selected'],
};
</script>

<style lang="scss" scoped>
.job-evaluation-job-card {
	width: 150px;
	height: 150px;
	border-radius: 4px;
	box-shadow: 0 2px 10px 0 rgba(242, 242, 242, 0.5);
	border: solid 2px var(--app-color-secondary);
	.job-evaluation-job-card-name {
		padding: 5px 10px;
		color: var(--app-color-secondary);
		font-size: 16px;
		font-weight: bold;
		font-stretch: normal;
		text-align: center;
		line-height: 16px;
	}
	.job-evaluation-job-card-rate {
		height: 30px;
		text-align: center;
		color: var(--app-color-primary);
		font-weight: bold;
	}
	&.selected {
		.job-evaluation-job-card-info {
			background-color: var(--app-color-secondary);
			.job-evaluation-job-card-name {
				color: white;
			}
		}
		.job-evaluation-job-card-rate {
			background-color: var(--app-color-primary);
			color: white;
			margin-left: -2px;
			margin-right: -2px;
			margin-bottom: -2px;
			border-bottom-left-radius: 4px;
			border-bottom-right-radius: 4px;
		}
	}
}
</style>



// WEBPACK FOOTER //
// src/modules/polls/components/custom/JobEvaluationPollPage/JobEvaluationJobCard.vue